import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from '@/pages/home/components/HeroBanner';
import HotGrid from '@/pages/home/components/HotGrid';
import FeatureGrid from '@/pages/home/components/FeatureGrid';
import CTASection from '@/pages/home/components/CTASection';
import Testimonial from '@/pages/home/components/Testimonial';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'http://818tp.cn/#organization',
      name: '吃瓜51网',
      url: 'http://818tp.cn/',
      description: '吃瓜51网汇聚吃瓜51爆料与51热门事件，每日独家更新网红塌房黑料，实时追踪不停歇',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'hello@818tp.cn',
        contactType: '爆料投稿',
      },
    },
    {
      '@type': 'WebSite',
      '@id': 'http://818tp.cn/#website',
      url: 'http://818tp.cn/',
      name: '吃瓜51网',
      publisher: { '@id': 'http://818tp.cn/#organization' },
    },
    {
      '@type': 'WebPage',
      '@id': 'http://818tp.cn/#webpage',
      url: 'http://818tp.cn/',
      name: '吃瓜51网 - 吃瓜51爆料与51热门事件每日独家更新',
      isPartOf: { '@id': 'http://818tp.cn/#website' },
      about: { '@id': 'http://818tp.cn/#organization' },
      primaryImageOfPage: {
        '@type': 'ImageObject',
        url: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20digital%20art%20composition%20with%20dramatic%20neon%20lime%20green%20accents%20and%20deep%20shadows&width=1800&height=900&seq=hero-bg-main&orientation=landscape',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <HeroBanner />
        <HotGrid />
        <FeatureGrid />
        <CTASection />
        <Testimonial />
      </main>
      <Footer />
    </>
  );
}